import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ArrowRight, TrendingUp, UserSearch, Megaphone, Beaker, CheckCircle } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const Conseils = () => {
  const { t } = useLanguage();

  const services = [
    {
      id: 'client-mystere',
      icon: UserSearch,
      title: t('professionnels.clientMystere'),
      desc: t('professionnels.clientMystereDesc'),
      features: [t('professionnels.visitesMysteres'), t('professionnels.appelsMysteres'), t('professionnels.evaluationAccueil'), t('professionnels.rapportRecommandations'), t('professionnels.suiviAmelioration')],
      link: '/professionnels/client-mystere'
    },
    {
      id: 'strategie',
      icon: TrendingUp,
      title: t('professionnels.strategie'),
      desc: t('professionnels.strategieDesc'),
      features: [t('professionnels.analyseMarche'), t('professionnels.objectifs'), t('professionnels.planAction'), t('professionnels.suiviKPI'), t('professionnels.optimisation')]
    },
    {
      id: 'marketing',
      icon: Megaphone,
      title: t('professionnels.marketing'),
      desc: t('professionnels.marketingDesc'),
      features: [t('professionnels.strategieDigital'), t('professionnels.creationSites'), t('professionnels.reseauxSociaux'), t('professionnels.creationContenu'), t('professionnels.campagnesPub')]
    },
    {
      id: 'hygiene',
      icon: Beaker,
      title: t('professionnels.hygiene'),
      desc: t('professionnels.hygieneDesc'),
      features: [t('professionnels.auditInstallations'), t('professionnels.conformite'), t('professionnels.plansSanitaires'), t('professionnels.formationPersonnel'), t('professionnels.certification')]
    }
  ];

  return (
    <div data-testid="conseils-page">
      <section className="page-header page-header-professionnels" data-testid="conseils-header">
        <p className="text-sm uppercase tracking-widest text-[#C9A227] mb-4 font-sans animate-fade-in">{t('conseils.tagline')}</p>
        <h1 className="font-serif text-4xl md:text-6xl text-white mb-6 animate-fade-in-delay-1">{t('conseils.heroTitle')}</h1>
        <div className="gold-line gold-line-center mb-6 animate-fade-in-delay-2"></div>
        <p className="text-white/80 text-lg max-w-2xl text-center animate-fade-in-delay-3">{t('conseils.heroSubtitle')}</p>
      </section>

      <div className="container-luxury pt-8">
        <Link to="/professionnels" className="inline-flex items-center gap-2 text-[#C9A227] hover:text-[#b08d1f] transition-colors text-sm" data-testid="conseils-back">
          <ArrowLeft className="w-4 h-4" /> {t('conseils.backToPro')}
        </Link>
      </div>

      <section className="section-luxury bg-[#FDFCF8] texture-overlay" data-testid="conseils-list">
        <div className="container-luxury">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {services.map((service) => (
              <div key={service.id} className="bg-white border border-[#F5EFD3] hover:border-[#C9A227] transition-all duration-300 group" data-testid={`conseil-${service.id}`}>
                <div className="p-8">
                  <div className="flex items-start gap-5 mb-6">
                    <div className="w-14 h-14 rounded-full border border-[#C9A227] flex items-center justify-center flex-shrink-0 group-hover:bg-[#C9A227] transition-all duration-500">
                      <service.icon className="w-7 h-7 text-[#C9A227] group-hover:text-white transition-colors duration-500" />
                    </div>
                    <div>
                      <h2 className="font-serif text-xl md:text-2xl text-[#1A1A1A] mb-2">{service.title}</h2>
                      <p className="text-gray-600 leading-relaxed">{service.desc}</p>
                    </div>
                  </div>
                  <ul className="space-y-3 mb-6">
                    {service.features.map((feature, i) => (
                      <li key={i} className="flex items-start gap-2">
                        <CheckCircle className="w-5 h-5 text-[#C9A227] flex-shrink-0 mt-0.5" />
                        <span className="text-gray-600 text-sm">{feature}</span>
                      </li>
                    ))}
                  </ul>
                  {service.link && (
                    <Link to={service.link} className="mt-2 btn-primary inline-flex items-center gap-2 text-sm" data-testid={`conseil-link-${service.id}`}>
                      {t('conseils.seeOffer')} <ArrowRight className="w-4 h-4" />
                    </Link>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section-luxury bg-[#1A1A1A]" data-testid="conseils-cta">
        <div className="container-luxury text-center max-w-3xl mx-auto">
          <h2 className="font-serif text-3xl md:text-4xl text-white mb-6">{t('conseils.ctaTitle')}</h2>
          <div className="gold-line gold-line-center mb-8"></div>
          <p className="text-white/70 text-lg mb-10">{t('conseils.ctaText')}</p>
          <Link to="/contact" className="btn-primary inline-flex items-center gap-2" data-testid="conseils-contact-cta">
            {t('conseils.contactUs')} <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Conseils;
